import EditDailyProduct from './EditDailyProduct'

export default EditDailyProduct



// WEBPACK FOOTER //
// ./src/components/DailyProducts/Edit/index.js